const routes = [
    {
        path: "/microsoft/team/groups",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "microsoftteamgroup_index"
        }
    },
    {
        path: "/microsoft/team/group/users/:id",
        component: () => import("../pages/TeamsGroupUser/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "microsoftteamgroupuser_index"
        },
    },
];

export default routes;
